export const TOGGLE_LOADING = 'branch/TOGGLE_LOADING'
export const TOGGLE_SUCCESS = 'branch/TOGGLE_SUCCESS'
export const SET_BRANCH_NAME = 'branch/SET_BRANCH_NAME'
export const RESET_BRANCH = 'branch/RESET_BRANCH'
